var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountrySk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_9386)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_9386",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_9386)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.3333H28V6.66663H0V13.3333Z",
    fill: "#0C47B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V13.3334H0V20Z",
    fill: "#E53B35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94965 3.33333C5.87499 3.33333 4.99243 4.1826 4.95113 5.25647L4.69188 11.9969C4.66841 12.6073 4.92509 13.1948 5.38882 13.5923L8.2645 16.0572C9.26314 16.9132 10.7368 16.9132 11.7354 16.0572L14.6111 13.5923C15.0748 13.1948 15.3315 12.6073 15.308 11.9969L15.0488 5.25647C15.0075 4.1826 14.1249 3.33333 13.0502 3.33333H6.94965Z",
    fill: "#F73744",
    stroke: "white",
    strokeWidth: 1.33333
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2858_9386",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 12,
    height: 16
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94965 3.33333C5.87499 3.33333 4.99243 4.1826 4.95113 5.25647L4.69188 11.9969C4.66841 12.6073 4.92509 13.1948 5.38882 13.5923L8.2645 16.0572C9.26314 16.9132 10.7368 16.9132 11.7354 16.0572L14.6111 13.5923C15.0748 13.1948 15.3315 12.6073 15.308 11.9969L15.0488 5.25647C15.0075 4.1826 14.1249 3.33333 13.0502 3.33333H6.94965Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2858_9386)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3335 10.9999C9.3335 10.8158 9.18426 10.6666 9.00016 10.6666H7.66683C7.48273 10.6666 7.3335 10.5173 7.3335 10.3333V9.66659C7.3335 9.48249 7.48273 9.33325 7.66683 9.33325H9.00016C9.18426 9.33325 9.3335 9.18401 9.3335 8.99992V8.33325C9.3335 8.14916 9.18426 7.99992 9.00016 7.99992H8.3335C8.1494 7.99992 8.00016 7.85068 8.00016 7.66659V6.99992C8.00016 6.81582 8.1494 6.66659 8.3335 6.66659H9.00016C9.18426 6.66659 9.3335 6.51735 9.3335 6.33325V5.66659C9.3335 5.48249 9.48273 5.33325 9.66683 5.33325H10.3335C10.5176 5.33325 10.6668 5.48249 10.6668 5.66659V6.33325C10.6668 6.51735 10.8161 6.66659 11.0002 6.66659H11.6668C11.8509 6.66659 12.0002 6.81582 12.0002 6.99992V7.66658C12.0002 7.85068 11.8509 7.99992 11.6668 7.99992H11.0002C10.8161 7.99992 10.6668 8.14916 10.6668 8.33325V8.99992C10.6668 9.18401 10.8161 9.33325 11.0002 9.33325H12.3335C12.5176 9.33325 12.6668 9.48249 12.6668 9.66659V10.3333C12.6668 10.5173 12.5176 10.6666 12.3335 10.6666H11.0002C10.8161 10.6666 10.6668 10.8158 10.6668 10.9999V12.9999C10.6668 13.184 10.5176 13.3333 10.3335 13.3333H9.66683C9.48273 13.3333 9.3335 13.184 9.3335 12.9999V10.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2034 13.4254C10.9887 12.9766 10.5305 12.6666 9.99984 12.6666C9.46917 12.6666 9.01091 12.9766 8.79629 13.4254C7.17536 13.6809 6 14.4384 6 15.3333C6 16.4379 7.79086 17.3333 10 17.3333C12.2091 17.3333 14 16.4379 14 15.3333C14 14.4384 12.8245 13.6808 11.2034 13.4254Z",
    fill: "#1251A1"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_9386"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountrySk);
export default __webpack_public_path__ + "static/media/Country=SK.c4922f99dea005121fa91c30d16d2cee.svg";
export { ForwardRef as ReactComponent };